module.exports = __webpack_public_path__ + "static/schaukel04-df6f59bd6cc0a29ff253286ab9719450.jpg";